import React from 'react';
import { useNode } from '@craftjs/core';
import { Button as MuiButton, Box } from '@mui/material';

export const ButtonSettings = () => {
  const {
    actions: { setProp },
    text,
    backgroundColor,
    color,
    link,
  } = useNode((node) => ({
    text: node.data.props.text,
    backgroundColor: node.data.props.backgroundColor,
    color: node.data.props.color,
    link: node.data.props.link,
  }));

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ mb: 2 }}>
        <label>Текст кнопки</label>
        <input
          type="text"
          value={text}
          onChange={(e) => setProp((props) => (props.text = e.target.value))}
          style={{ width: '100%', padding: '8px' }}
        />
      </Box>
      
      <Box sx={{ mb: 2 }}>
        <label>Цвет фона</label>
        <input
          type="color"
          value={backgroundColor}
          onChange={(e) => setProp((props) => (props.backgroundColor = e.target.value))}
        />
      </Box>
      
      <Box sx={{ mb: 2 }}>
        <label>Цвет текста</label>
        <input
          type="color"
          value={color}
          onChange={(e) => setProp((props) => (props.color = e.target.value))}
        />
      </Box>
      
      <Box sx={{ mb: 2 }}>
        <label>Ссылка</label>
        <input
          type="text"
          value={link}
          onChange={(e) => setProp((props) => (props.link = e.target.value))}
          placeholder="https://example.com"
          style={{ width: '100%', padding: '8px' }}
        />
      </Box>
    </Box>
  );
};

export const Button = ({ text, backgroundColor, color, link }) => {
  const {
    connectors: { connect, drag },
    selected,
  } = useNode((state) => ({
    selected: state.events.selected,
  }));

  return (
    <Box
      ref={(ref) => connect(drag(ref))}
      sx={{
        p: 2,
        display: 'inline-block',
        border: selected ? '2px solid #00ACC1' : '2px solid transparent',
        cursor: 'move',
        '&:hover': {
          border: '2px dashed #00ACC1',
        },
      }}
    >
      <MuiButton
        variant="contained"
        sx={{
          backgroundColor,
          color,
          '&:hover': {
            backgroundColor: backgroundColor,
            opacity: 0.9,
          },
        }}
        onClick={() => link && window.open(link, '_self')}
      >
        {text}
      </MuiButton>
    </Box>
  );
};

Button.craft = {
  props: {
    text: 'Кнопка',
    backgroundColor: '#00ACC1',
    color: '#ffffff',
    link: '',
  },
  related: {
    settings: ButtonSettings,
  },
};
